import { useSelector } from 'react-redux';

    const RenderVideo = ({youtube, r2}) => {
        const kiosk = useSelector(state => state.kiosk);
        // KIOSK MODE → local/R2 video
        if (kiosk && r2) 
            return (
                <video
                    controls
                    playsInline
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        borderRadius: '12px',
                        objectFit: 'cover',
                    }}
                >
                    <source src={r2} type="video/mp4" />
                    Your browser does not support HTML5 video.
                </video>
            );

        // NORMAL MODE → YouTube iframe
        return (
            <iframe
                src={youtube}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '12px',
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded YouTube Video"
            />
        );
    };

    export default RenderVideo;